import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 9,
			fill: "#FF3131"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 5V13",
			stroke: "white",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 9L5 9",
			stroke: "white",
			strokeLinejoin: "round"
		})
	]
});
export default SvgNewIcon;
